// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-prestige -> dietz-property-group-prestige -> brookstone-apartments
// Generated: 2026-09-23T21:56:39.376Z
// Counts: 1 design, 12 content, 3 slot group, 2 collection binding, 7 section, 0 style

export const designOverrides = {
  "design.block:multihub-lead-form.color.primary": {
    "cssVariable": "--vibe-color-primary",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_secondary_color"
  }
};

export const contentOverrides = {
  "header.interactive_map_show_if_exists": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_engrain_sightmap_url"
  },
  "interactivemapsection.map_block": {
    "overrideType": "VALUE",
    "customValue": "engrain-sitemap",
    "generatedValue": null,
    "mappedField": null
  },
  "adtaxi-tracking.profile": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_adtaxi_domain"
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "right-middle",
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "knock-chatbot.api_token": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_knock_company_token"
  },
  "scheduletourform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore spacious two- and three-bedroom apartment floor plans at Brookstone Apartments in Bellefontaine, OH. Our thoughtfully designed layouts provide comfortable living spaces complemented by convenient apartment and community features.</p><p>Brookstone participates in Section 8, LIHTC, and HUD affordable housing programs. Apartment homes are income-restricted, and applicants must meet applicable eligibility requirements, including an income limit of 60% of the Area Median Income (AMI).</p><p>Browse our available floor plans below and contact our leasing team to learn more about current availability, income qualifications, and the application process.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Affordable Two- and Three-Bedroom Apartments in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Brookstone Apartments, an affordable housing community offering spacious two- and three-bedroom apartments in Bellefontaine, OH. Our apartment homes combine comfortable layouts with convenient features, while community amenities include laundry facilities, professional management, controlled access, and a playground.</p><p>Brookstone participates in Section 8, the Low-Income Housing Tax Credit (LIHTC) program, and HUD affordable housing programs. Our apartment homes are income-restricted, and applicants must meet applicable eligibility requirements, including an income limit of 60% of the Area Median Income (AMI).</p><p>Explore affordable apartments in Bellefontaine, OH, and contact our leasing team to learn more about current availability, income qualifications, and the application process.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Affordable Apartments in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "petscallout.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019e85db-45c6-7570-8b98-f085354e1af6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Woman holding a dog indoors."
      }
    }
  },
  "hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167348/019d63b1-b1c5-704a-81ea-9f2c338044e7.webp"
      }
    }
  }
};

export const collectionBindingOverrides = {
  "communityamenitieslist.items": {
    "limit": null,
    "hiddenIds": [
      "ec_3b9a2956e84f6e5aab41a742"
    ],
    "orderedIds": null,
    "hiddenIndices": [
      1
    ],
    "ordering": null,
    "customItems": null
  },
  "interioramenitieslist.items": {
    "limit": null,
    "hiddenIds": [
      "ec_ed8f85ac2291d0a50d889414",
      "ec_bb7735158daa22b6e026a8b8"
    ],
    "orderedIds": null,
    "hiddenIndices": [
      1,
      3
    ],
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "adtaxi-tracking",
      "blockId": "adtaxi-tracking",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "knock-chatbot",
      "blockId": "knock-chatbot",
      "position": 0
    },
    {
      "sectionId": "realpage-calendar",
      "blockId": "realpage-calendar",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
